export default "__VITE_ASSET__BYc$IxXo__"